import React, { useState, useLayoutEffect } from "react";

  const CustomButton = ({onClick,color,title,largebutton, style,href}) => {


  return (
    <a href={href ? href : "#"} 
    onClick={onClick}
    style={style}
    className={color=="bright" ?
    // "thm-btn pricing-one__btn"
    "thm-btn-bright pricing-one__btn" 
    : "thm-btn pricing-one__btn"}><span style={{textAlign:'center', width:'100%'}}>
      {title}</span></a>

  //   <Button variant="contained" disableElevation className=
  //   {color=='warn'? 'btn-stand btn-gradient-warn' :color=='bright'? 
  //   'btn-stand btn-gradient-bright':color=='pastel'? 
  //   'btn-stand btn-gradient-pastel':
  //   color=='orange'? 
  //   'btn-stand btn-gradient-orange'
  //   :'btn-stand btn-gradient-bright'}
  //   style={{transition: '0.5s',color:'white', padding: largebutton ? '2%' : null,
  // }}
  //   onClick={onClick}>
  //   <p className='button-text' style={{margin:0}}>{title}</p>
  //   </Button>
  );
};

export default CustomButton;
